
const useSoloEvent = () => {
    const isSoloEvent = JSON.parse(localStorage.getItem('soloGift'));
    return isSoloEvent
}

export default useSoloEvent
